import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import classNames from 'classnames';
import OutputText from '@ey/canvascoreservices/OutputText';
import {contentIcAddCircle24px} from '@ey/motif-react-wrapper/assets/icons';
import {MotifNavigationIcClose24px, IconoirProhibition} from '@ey-xd/motif-icon';
import env from '../../util/env';
import utility from '../../util/utilityfunctions';
import {labels} from '../../util/utils';
import {serviceURL} from '../../util/uiconstants';
import {delegateTabs, UserLookupType} from '../../util/uiconstants';

import {createDelegate} from '../../actions/Delegate/delegateaction';
import {getUserPreferences} from '../../actions/UserPreferences/userpreferencesaction';
import {setIsModalOpen} from '../../actions/AccessGroups/SetIsModalOpen';
import {raiseJSValidationError, clearErrors} from '../../actions/erroractions';

import UserSearch from '../Common/Search/CustomizedUsersearch';

import Button from '../CoreWrappers/Button';
import DeleteModal from '../UserSettings/DeleteModal';
import TabNavigation from '../CoreWrappers/TabNavigation';
import IconMessage from '../CoreWrappers/IconMessage';
import ErrorSummary from '../Common/ErrorSummary/ErrorSummary';
import Modal from '../CoreWrappers/Modal';
import StyledDelegateAccessModal from './StyledDelegateAccessModal';
import User from '../CoreWrappers/User';

function DelegateAccessModal(props) {
	const [userList, setUserList] = useState([{key: `user_${0}`, id: `${0}`, firstName: '', isDuplicate: false}]);
	const [Usercounter, setUserCounter] = useState(1);
	const [delegateTo, setdelegateTo] = useState([]);
	const [userError, setUserError] = useState(false);
	const [delegateToCount, setDelegateToCount] = useState(1);
	const [saveFailed, setSaveFailed] = useState(false);
	const [toastErrorMessage, setToastErrorMessage] = useState('');
	// for Remove delegates functionality
	const [showDeleteModal, setshowDeleteModal] = useState(false);
	const [selectedUser, setSelectedUser] = useState({});
	const [isSaving, setIsSaving] = useState(false);

	const dispatch = useDispatch();
	const user = useSelector((store) => store.userPreferences);

	const delegateToTab = {
		id: delegateTabs.delegateTo,
		label: labels.delegateTo
	};

	const delegateFromTab = {
		id: delegateTabs.delegateFrom,
		label: labels.delegateFrom
	};

	const manageDelegateTabs = [delegateToTab, delegateFromTab];

	const [delegateActiveTab, setDelegateActiveTab] = useState(delegateToTab);
	const onUserClear = (selectedUser, key) => {
		if (selectedUser !== '') {
			var idx = delegateTo.findIndex((x) => x.emailAddress !== selectedUser.allProps.email);
			var newDelegateTo = [...delegateTo];
			newDelegateTo.splice(idx, 1);
			setdelegateTo(newDelegateTo);
			let updatedUserList = userList.map((n) => {
				if (n.key === key) {
					let x = {
						...n,
						isDuplicate: false,
						emailAddress: ''
					};

					return x;
				}
				return n;
			});
			setUserList(updatedUserList);
			setUserError(false);
		}
	};

	const onUserSelectionChange = (user, key) => {
		setdelegateTo([
			...delegateTo,
			{
				id: key,
				firstName: `${user.allProps.firstName}`,
				lastName: `${user.allProps.lastName}`,
				emailAddress: `${user.allProps.email}`,
				gui: `${user.allProps.gui}`
			}
		]);
		let isduplicate = validateIsUserDuplicate(user.allProps.email);
		let updatedUserList = userList.map((n) => {
			if (n.key === key) {
				let x = {
					...n,
					emailAddress: user.allProps.email,
					isDuplicate: isduplicate
				};

				return x;
			}
			return n;
		});
		setUserList(updatedUserList);
		if (isduplicate) {
			setUserError(true);
		} else {
			setUserError(false);
		}
	};
	// Add user row
	const addDelegateButtonClick = () => {
		setUserList([
			...userList,
			{key: `user_${Usercounter}`, id: `${Usercounter}`, firstName: '', emailAddress: '', isDuplicate: false}
		]);
		setUserCounter(Usercounter + 1);
		setDelegateToCount(delegateToCount + 1);
		setUserError(false);
	};

	//Remove user row
	const removeInputRowUser = (e) => {
		const newUserList = userList.filter((x) => x.key !== e.currentTarget.getAttribute('userListKey'));

		let currentUserEmail = e.currentTarget.getAttribute('emailAddress');
		// remove one isntance of selected email in case of duplicate
		let isduplicate =
			(_.size(newUserList) > 0 && newUserList.filter((x) => x.emailAddress === currentUserEmail).length > 1) ||
			user.delegatedTo.filter((x) => x.emailAddress === currentUserEmail).length > 1;
		let updatedUserList = newUserList.map((n) => {
			if (n.emailAddress === currentUserEmail) {
				let x = {
					...n,
					isDuplicate: isduplicate
				};

				return x;
			}
			return n;
		});
		setUserList(updatedUserList);

		var idx = delegateTo.findIndex((x) => x.emailAddress === e.currentTarget.getAttribute('emailAddress'));
		var newDelegateTo = [...delegateTo];
		newDelegateTo.splice(idx, 1);
		setdelegateTo(newDelegateTo);
		setDelegateToCount(delegateToCount - 1);
	};

	const isDataValid = () => {
		return !userList.some((x) => !x.emailAddress) && !userList.some((x) => x.isDuplicate);
	};
	const handelSaveDelegate = () => {
		if (isDataValid()) {
			setUserError(false);
			saveDelegate();
		} else {
			setUserError(true);
		}
	};
	const saveDelegate = () => {
		setIsSaving(true);
		if (delegateToCount > 0) {
			let model = {
				delegateTo: delegateTo
			};
			dispatch(createDelegate(env.getBaseURL(serviceURL) + 'Users/Delegate', {body: model}))
				.then(() => {
					closeModalDialogue();
					dispatch(getUserPreferences(env.getBaseURL(serviceURL) + 'Users/Me')).then(() => {
						props.setModalVisibility(false);
					});
				})
				.catch((error) => {
					const displayError = utility.getErrorFromResponse(error);
					const errorMessage = utility.getErrorMessageFromResponse(displayError);
					setToastErrorMessage(errorMessage);
					setSaveFailed(true);
					dispatch(setIsModalOpen(true)).then(() => {
						dispatch(raiseJSValidationError(errorMessage));
					});
				})
				.finally(() => {
					setIsSaving(false);
				});
		} else {
			closeModalDialogue();
		}
	};

	const closeModalDialogue = () => {
		setUserCounter(1);
		setUserList([{key: `user_${0}`, id: `${0}`, firstName: ''}]);
		setdelegateTo([]);
		setDelegateToCount(1);
		setUserError(false);
		setSaveFailed(false);
		dispatch(clearErrors()).then(() => {
			dispatch(setIsModalOpen(false));
		});
		props.setModalVisibility(false);
	};
	//for delete delegates pop up
	const deleteMember = (item) => {
		setSelectedUser(item);
		setshowDeleteModal(!showDeleteModal);
	};
	const validateIsUserDuplicate = (email) => {
		return (
			(_.size(delegateTo) > 0 && delegateTo.some((x) => x.emailAddress === email)) ||
			user.delegatedTo.some((x) => x.emailAddress === email)
		);
	};

	const modalProps = {
		show: props.showModal,
		modalsize: 'small',
		labels: {
			modalConfirmBtnLabel: labels.save,
			modalCancelBtnLabel: labels.cancelLabel,
			modalCloseBtnTitletip: labels.closeLabel
		},
		headerText: labels.delegateAccess,
		isOkDisabled: isSaving,
		isLoading: isSaving,
		isCancelDisabled: isSaving,
		onOkClick: handelSaveDelegate,
		onClose: () => {
			setUserCounter(1);
			setUserList([]);
			setdelegateTo([]);
			props.toggleModalVisibility();
			setUserList([{key: `user_${0}`, id: `${0}`, firstName: ''}]);
			setUserError(false);
			setDelegateToCount(1);
		}
	};

	const renderAddAnotherButton = () => {
		const props = {
			variant: 'text-alt',
			label: labels.addAnother,
			size: 'medium',
			svg: contentIcAddCircle24px,
			onClick: addDelegateButtonClick
		};

		return <Button {...props} />;
	};

	const renderTabNavigation = () => {
		const props = {
			tabs: manageDelegateTabs,
			activeTab: delegateActiveTab,
			setTab: (newTab) => setDelegateActiveTab(newTab),
			size: 'md'
		};

		return <TabNavigation {...props} />;
	};

	const renderUser = (firstName, lastName, email) => {
		const props = {
			firstName,
			lastName,
			email,
			showInfo: false,
			renderExtra: () => (
				<OutputText body2 light>
					{email}
				</OutputText>
			)
		};

		return <User {...props} />;
	};

	const renderDelegateEmptyMessage = () => {
		return <IconMessage className="placeholder" icon={IconoirProhibition} subTitle={labels.delegateFromMsg} />;
	};

	const renderList = (tabId, list) => {
		const isActive = delegateActiveTab.id === tabId;
		if (!isActive) return false;
		const isEmpty = !list?.length > 0;
		const showButton = tabId === delegateTabs.delegateTo;

		return (
			<section className={classNames('delegate-list', {empty: isEmpty})}>
				{!isEmpty
					? list.map((item, index) => (
							<section key={item.emailAddress} className="delegate-user-data">
								{renderUser(item.firstName, item.lastName, item.emailAddress)}
								{showButton && (
									<Button
										svg={MotifNavigationIcClose24px}
										title={labels.remove}
										variant="ghost"
										iconSize={20}
										onClick={() => deleteMember(item)}
									/>
								)}
							</section>
					  ))
					: renderDelegateEmptyMessage()}
			</section>
		);
	};

	return (
		<Modal {...modalProps}>
			<ErrorSummary />
			<StyledDelegateAccessModal>
				<OutputText body1 light>
					{labels.delegateInstruction}
				</OutputText>
				<OutputText body1 regular>
					{labels.addDelegates}
				</OutputText>

				<div className="row">{renderAddAnotherButton()}</div>

				<div className="add-delegate-list">
					{userList.map((user) => (
						<div className="add-delegate-item" key={user.key}>
							<UserSearch
								key={user.key}
								id={user.key}
								userListKey={user.key}
								user={user}
								onUserClear={onUserClear}
								onUserSelectionChange={onUserSelectionChange}
								lookupType={props.isThirdPartyUser ? UserLookupType.ThirdPartyUser : UserLookupType.NotSpecified}
								showNameOnSelect={true}
								userError={user.isDuplicate}
								maxSearchLength={50}
								doNotDispatchUserEmpty={true}
								hideClearIcon={true}
							/>
							<Button
								userListKey={user.key}
								svg={MotifNavigationIcClose24px}
								title={labels.remove}
								variant={'ghost'}
								iconSize={20}
								onClick={(e) => removeInputRowUser(e)}
							/>
						</div>
					))}
				</div>

				{renderTabNavigation()}

				{renderList(delegateTabs.delegateTo, user?.delegatedTo)}
				{renderList(delegateTabs.delegateFrom, user?.delegatedFrom)}

				{showDeleteModal && (
					<DeleteModal
						selectedUser={selectedUser}
						show={showDeleteModal}
						setShowDeleteModal={setshowDeleteModal}
						onDeleteSuccess={() => {}}
					/>
				)}
			</StyledDelegateAccessModal>
		</Modal>
	);
}

export default DelegateAccessModal;
